import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-6 px-4 sm:px-6 bg-brand-cream border-y-4 border-brand-gold/30 scroll-mt-2" data-id="element-119">
      <div className="text-center mb-3" data-id="element-120">
        <p className="text-xs font-button font-bold text-brand-gold uppercase tracking-widest mb-1" data-id="element-121">
          SPECIAL OFFER — COMPLETE 6-IN-1 PACK
        </p>
        <p className="text-sm font-bold text-brand-taupe mb-2 leading-tight" data-id="element-122">
          Access the system now and transform your classes today
        </p>
        <div className="inline-block bg-brand-rose text-white px-3 py-1 rounded shadow-sm mb-3" data-id="element-123">
          <p className="font-button font-bold text-sm tracking-wide" data-id="element-124">
            Dance Ready 6-in-1 Box Set
          </p>
        </div>
        <a href="https://danceready.impultienda.ar/checkout" className="block cursor-pointer" data-id="element-125">
          <img src="https://cdn.magicpatterns.com/uploads/vNhitVHkq5bJ6yeknhzbRq/ChatGPT-Image-14-jun-2026_-10_23_58-p.m..webp" alt="Dance Ready 6-in-1 Box Set" className="w-full max-w-[200px] mx-auto object-contain drop-shadow-lg mb-3" data-id="element-126" />
        </a>
      </div>

      <div className="bg-white border-4 border-brand-gold rounded-lg p-4 text-center relative mb-3 shadow-xl" data-id="element-127">
        <div className="mb-3" data-id="element-128">
          <p className="text-sm font-bold text-brand-taupe/70 mb-0.5" data-id="element-129">
            Normal Price: <span className="line-through" data-id="element-130">$97 USD</span>
          </p>
          <p className="text-base font-button font-bold text-red-600 mb-1 uppercase tracking-wide" data-id="element-131">
            🔥 72% OFF — LAUNCH OFFER
          </p>
          <p className="text-5xl font-heading font-bold text-brand-taupe mb-0.5 leading-none" data-id="element-132">
            $27 USD
          </p>
          <p className="text-[10px] font-bold text-brand-taupe/60 uppercase tracking-wider" data-id="element-133">
            Pay in your local currency
          </p>
        </div>

        <div className="bg-red-50 border border-red-200 rounded p-2 mb-4" data-id="element-134">
          <p className="text-xs font-bold text-red-600 mb-1.5 uppercase tracking-tight" data-id="element-135">
            🔥 Last chance! The price increases when the timer ends.
          </p>
          <div className="flex justify-center gap-2" data-id="element-136">
            <div className="text-center" data-id="element-137">
              <div className="bg-brand-taupe text-white text-xl font-bold px-2 py-1 rounded shadow-inner leading-none" data-id="element-138">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-taupe/70 mt-0.5 tracking-wider" data-id="element-139">
                HOURS
              </p>
            </div>
            <div className="text-lg font-bold text-brand-taupe mt-0.5" data-id="element-140">:</div>
            <div className="text-center" data-id="element-141">
              <div className="bg-brand-taupe text-white text-xl font-bold px-2 py-1 rounded shadow-inner leading-none" data-id="element-142">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-taupe/70 mt-0.5 tracking-wider" data-id="element-143">
                MINUTES
              </p>
            </div>
            <div className="text-lg font-bold text-brand-taupe mt-0.5" data-id="element-144">:</div>
            <div className="text-center" data-id="element-145">
              <div className="bg-brand-taupe text-white text-xl font-bold px-2 py-1 rounded shadow-inner leading-none" data-id="element-146">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-taupe/70 mt-0.5 tracking-wider" data-id="element-147">
                SECONDS
              </p>
            </div>
          </div>
        </div>

        <CTAButton href="https://danceready.impultienda.ar/checkout" data-id="element-148">
          🚀 YES, I WANT THE 6-IN-1 PACK
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-xs text-brand-taupe font-bold" data-id="element-149">
        <div className="flex items-center gap-1" data-id="element-150">
          <Star className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-151" />
          <span data-id="element-152">4.9/5 — Verified Reviews</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-153">
          <Shield className="w-3.5 h-3.5 text-brand-rose" data-id="element-154" />
          <span data-id="element-155">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}